export const URLS = {
  GET_ORGANISATIONS:
    "/api/services/agrierp/AgriUserAccount/GetLinkedOrganisations",
};
